<template>
  <div>
    <div class="page-header clear-filter" filter-color="green">
      <parallax
          class="page-header-image"
          style="background-image:url('img/header.jpg')"
      >
      </parallax>
    </div>
    <carousel-section></carousel-section>
    <tabs-section></tabs-section>
  </div>
</template>
<script>
import CarouselSection from './components/CarouselSection';
import TabsSection from './components/Tabs';


export default {
  name: 'index',
  bodyClass: 'index-page',
  components: {
    TabsSection,
    CarouselSection
  }
};
</script>
<style></style>
